import React, { Component } from "react"
import ReactApexChart from "react-apexcharts"

class TransactionPiechart extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      series: [10, 10, 40],
      options: {
        labels: ["A", "B", "C"],
        colors:['#41b8d5', '#2d8bba','#6ce5e8'],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          verticalAlign: "middle",
          floating: false,
          fontSize: "14px",
          offsetX: 0,
          offsetY: -10,
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                height: 240,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    }
  }
  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="pie"
          height="350"
          className="apex-charts"
        />
      </React.Fragment>
    )
  }
}

export default TransactionPiechart
